import {
  CategoryFacet,
  CategoryFacetValue,
  DateFacet,
  LocationFacet,
  NumericFacet,
  RegularFacet,
  RegularFacetValue,
} from '@coveo/headless/commerce';
import { FacetValue } from '@usf/product-types';

export const DELIVERY_METHOD_FACET_FIELD_NAME = 'tenant~delivery_method';
export const DELIVERY_METHOD_US_FOODS = 'us foods delivered';

export interface FacetFilter {
  fieldName: string;
  facetValue: FacetValue;
}

export interface FacetChipViewModel {
  facet: RegularFacet | CategoryFacet;
  facetValue: RegularFacetValue | CategoryFacetValue;
}
